export const lang = [
  {//0
    'en': 'All locations & granges',
    'nl': 'Alle locaties & uithoven'
  },
  {//1
    'en': 'Monastery',
    'nl': 'Klooster'
  },
  {//2
    'en': 'View on kloosterlijst website',
    'nl': 'Bekijk op kloosterlijst website'
  },
  {//3
    'en': 'Grange',
    'nl': 'Uithof'
  }
];
